
import compareObject from '~/utils/compare'

export const state = () => ({
  apiUrlPath: {
    'splitDnsConfig': '/api/sm/splitdns/config',
    'splitDnsAdvConfig': '/api/sm/splitdns/{type}',
    'splitZones': '/api/sm/splitdns/{type}/zone',
    'splitZoneHosts': '/api/sm/splitdns/{type}/zone/{zone_id}/hosts',
    'splitReverseZones': '/api/sm/splitdns/{type}/reverse-zones',
    'splitReverseZoneHosts': '/api/sm/splitdns/{type}/reverse-zones/{zone_id}/hosts'
  },
  // zone role-type
  zoneRoleType: [
    {label: 'Master', value: 0},
    {label: 'Slave', value: 1}
  ],
  // zone host type
  zoneHostType: [
    {label: 'SOA', value: 0},
    {label: 'MX', value: 1},
    {label: 'NS', value: 2},
    {label: 'A', value: 3},
    {label: 'CNAME', value: 5}
  ],
  // reverseZone host type
  reverseZoneHostType: [
    {label: 'SOA', value: 0},
    {label: 'MX', value: 1},
    {label: 'NS', value: 2},
    {label: 'PTR', value: 4},
    {label: 'CNAME', value: 5}
  ],
  warningPageDataList: [],
  dialogMode: '',
  dialogName: '',
  dialogTitleName: '',
  dialogFooterButton: [],
  dialogParam: [],
  selectedItem: {},
  // common responseData
  resResultData: {reqType: '', resStatus: 404, resCode: 'nok', resMessage: ''},
  // clone store
  cloneSplitDnsSettings: {
    forward: 0,
    notify: 0,
    recursion: 0,
    transfers_format: 0,
    max_transfer_time_in: 0,
    transfer_in: 0,
    cleaning_interval: 0,
    interface_interval: 0,
    lame_ttl: 0,
    max_ncache_ttl: 0
  },
  // split dns
  splitDnsDefault: {enable: 0, type: ''},
  splitDnsNormaSetting: {forward: 0, notify: 0, recursion: 0, transfers_format: 0, max_transfer_time_in: 0, transfer_in: 0, cleaning_interval: 0, interface_interval: 0, lame_ttl: 0, max_ncache_ttl: 0},
  splitDnsSettings: {
    normalSet: {
      forward: 0,
      notify: 0,
      recursion: 0,
      transfers_format: 0,
      max_transfer_time_in: 0,
      transfer_in: 0,
      cleaning_interval: 0,
      interface_interval: 0,
      lame_ttl: 0,
      max_ncache_ttl: 0
    },
    listenon_list: [],
    forwarders_list: [],
    allow_query: {allow_all: 0, allow_list: []},
    allow_recursion: {allow_all: 0, allow_list: []},
    allow_transfer: {allow_all: 0, allow_list: []}
  },
  splitDnsReqSettings: {
    forward: 0,
    notify: 0,
    recursion: 0,
    transfers_format: 0,
    max_transfer_time_in: 0,
    transfer_in: 0,
    cleaning_interval: 0,
    interface_interval: 0,
    lame_ttl: 0,
    max_ncache_ttl: 0,
    listenon_list: [],
    forwarders_list: [],
    allow_query: {allow_all: 0, allow_list: []},
    allow_recursion: {allow_all: 0, allow_list: []},
    allow_transfer: {allow_all: 0, allow_list: []}
  }
})

export const mutations = {
  // reset splitdns advance config
  resetSplitDnsAdvConfigData (state) {
    state.splitDnsSettings = {
      normalSet: {
        forward: 0,
        notify: 0,
        recursion: 0,
        transfers_format: 0,
        max_transfer_time_in: 0,
        transfer_in: 0,
        cleaning_interval: 0,
        interface_interval: 0,
        lame_ttl: 0,
        max_ncache_ttl: 0
      },
      listenon_list: [],
      forwarders_list: [],
      allow_query: {
        allow_all: 0,
        allow_list: []
      },
      allow_recusion: {
        allow_all: 0,
        allow_list: []
      },
      allow_transfer: {
        allow_all: 0,
        allow_list: []
      }
    }
    state.splitDnsNormaSetting = {
      forward: 0,
      notify: 0,
      recursion: 0,
      transfers_format: 0,
      max_transfer_time_in: 0,
      transfer_in: 0,
      cleaning_interval: 0,
      interface_interval: 0,
      lame_ttl: 0,
      max_ncache_ttl: 0
    }
  },
  // set splitDns configData
  setSplitDnsAdvConfigData (state, data) {
    if (data !== null) {
      // original total data.
      state.splitDnsSettings = data
      // convert array to {ip}'s array
      const listenonList = _.cloneDeep(data.listenon_list)
      state.splitDnsSettings.listenon_list = []
      for (const listenonip of listenonList) {
        state.splitDnsSettings.listenon_list.push({ip: listenonip})
      }
      const forwardList = _.cloneDeep(data.forwarders_list)
      state.splitDnsSettings.forwarders_list = []
      for (const forwardip of forwardList) {
        state.splitDnsSettings.forwarders_list.push({ip: forwardip})
      }
      const allowList = _.cloneDeep(data.allow_query.allow_list)
      if (allowList !== undefined && allowList.length > 0) {
        state.splitDnsSettings.allow_query.allow_list = []
        for (const allowip of allowList) {
          state.splitDnsSettings.allow_query.allow_list.push({ip: allowip})
        }
      }
      const allowRecursion = _.cloneDeep(data.allow_recursion.allow_list)
      if (allowRecursion !== undefined && allowRecursion.length > 0) {
        state.splitDnsSettings.allow_recursion.allow_list = []
        for (const allowip of allowRecursion) {
          state.splitDnsSettings.allow_recursion.allow_list.push({ip: allowip})
        }
      }
      const allowTransfer = _.cloneDeep(data.allow_transfer.allow_list)
      if (allowTransfer !== undefined && allowTransfer.length > 0) {
        state.splitDnsSettings.allow_transfer.allow_list = []
        for (const allowip of allowTransfer) {
          state.splitDnsSettings.allow_transfer.allow_list.push({ip: allowip})
        }
      }
      // real code( normal set info )
      state.splitDnsNormaSetting.forward = data.forward
      state.splitDnsNormaSetting.notify = data.notify
      state.splitDnsNormaSetting.recursion = data.recursion
      state.splitDnsNormaSetting.transfers_format = data.transfers_format
      state.splitDnsNormaSetting.max_transfer_time_in = data.max_transfer_time_in
      state.splitDnsNormaSetting.transfer_in = data.transfer_in
      state.splitDnsNormaSetting.cleaning_interval = data.cleaning_interval
      state.splitDnsNormaSetting.interface_interval = data.interface_interval
      state.splitDnsNormaSetting.lame_ttl = data.lame_ttl
      state.splitDnsNormaSetting.max_ncache_ttl = data.max_ncache_ttl
      // copy clone by normalSetting
      state.cloneSplitDnsSettings = _.cloneDeep(state.splitDnsNormaSetting)
    }
  },
  // reset normalSet's info
  resetSplitDnsNormalSetData (state) {
    state.splitDnsNormaSetting = {
      forward: 0,
      notify: 0,
      recursion: 0,
      transfers_format: 0,
      max_transfer_time_in: 0,
      transfer_in: 0,
      cleaning_interval: 0,
      interface_interval: 0,
      lame_ttl: 0,
      max_ncache_ttl: 0
    }
  },
  // set normalSet's info
  setSplitDnsNormalSetData (state, data) {
    if (data !== null) {
      state.splitDnsSettings.normalSet = data
    }
  },
  // reset splitDnsAdvance set for request
  resetSplitDnsRequestSetData (state) {
    state.splitDnsReqSettings = {
      forward: 0,
      notify: 0,
      recursion: 0,
      transfers_format: 0,
      max_transfer_time_in: 0,
      transfer_in: 0,
      cleaning_interval: 0,
      interface_interval: 0,
      lame_ttl: 0,
      max_ncache_ttl: 0,
      listenon_list: [],
      forwarders_list: [],
      allow_query: {
        allow_all: 0,
        allow_list: []
      },
      allow_recursion: {
        allow_all: 0,
        allow_list: []
      },
      allow_transfer: {
        allow_all: 0,
        allow_list: []
      }
    }
  },
  // set splitDnsAdvance set for request
  setSplitDnsRequestSetData (state, data) {
    if (data !== undefined) {
      state.splitDnsReqSettings.forward = data.normalSet.forward
      state.splitDnsReqSettings.notify = data.normalSet.notify
      state.splitDnsReqSettings.recursion = data.normalSet.recursion
      state.splitDnsReqSettings.transfers_format = data.normalSet.transfers_format
      state.splitDnsReqSettings.max_transfer_time_in = data.normalSet.max_transfer_time_in
      state.splitDnsReqSettings.transfer_in = data.normalSet.transfer_in
      state.splitDnsReqSettings.cleaning_interval = data.normalSet.cleaning_interval
      state.splitDnsReqSettings.interface_interval = data.normalSet.interface_interval
      state.splitDnsReqSettings.lame_ttl = data.normalSet.lame_ttl
      state.splitDnsReqSettings.max_ncache_ttl = data.normalSet.max_ncache_ttl
      for (const listenon of data.listenon_list) {
        state.splitDnsReqSettings.listenon_list.push(listenon.ip)
      }
      for (const forwarders of data.forwarders_list) {
        state.splitDnsReqSettings.forwarders_list.push(forwarders.ip)
      }
      state.splitDnsReqSettings.allow_query.allow_all = data.allow_query.allow_all
      for (const allowList of data.allow_query.allow_list) {
        state.splitDnsReqSettings.allow_query.allow_list.push(allowList.ip)
      }
      state.splitDnsReqSettings.allow_recursion.allow_all = data.allow_recursion.allow_all
      for (const allowList of data.allow_recursion.allow_list) {
        state.splitDnsReqSettings.allow_recursion.allow_list.push(allowList.ip)
      }
      state.splitDnsReqSettings.allow_transfer.allow_all = data.allow_transfer.allow_all
      for (const allowList of data.allow_transfer.allow_list) {
        state.splitDnsReqSettings.allow_transfer.allow_list.push(allowList.ip)
      }
    }
  },
  // add listen-on's ip list
  addSplitDnsListenonData (state, data) {
    if (data !== null) {
      state.splitDnsSettings.listenon_list.push(data)
    }
  },
  // delete listen-on's ip list
  delSplitDnsListenonData (state, itemIndexList) {
    if (itemIndexList !== null && itemIndexList !== undefined) {
      itemIndexList = _.orderBy(itemIndexList, ['itemIndex'], ['desc'])
      for (const item of itemIndexList) {
        state.splitDnsSettings.listenon_list.splice(item.itemIndex, 1)
      }
    }
  },
  // add forwarders's ip list
  addSplitDnsForwardersData (state, data) {
    if (data !== null) {
      state.splitDnsSettings.forwarders_list.push(data)
    }
  },
  // delete forwarders's ip list
  delSplitDnsForwardersData (state, itemIndexList) {
    if (itemIndexList !== null && itemIndexList !== undefined) {
      for (const item of itemIndexList) {
        state.splitDnsSettings.forwarders_list.splice(item.itemIndex, 1)
      }
    }
  },
  // add allowQuery's ip list
  addSplitDnsAllowqueryData (state, data) {
    if (data !== null) {
      state.splitDnsSettings.allow_query.allow_list.push(data)
    }
  },
  // delete allowQuery's ip list
  delSplitDnsAllowqueryData (state, itemIndexList) {
    if (itemIndexList !== null && itemIndexList !== undefined) {
      for (const item of itemIndexList) {
        state.splitDnsSettings.allow_query.allow_list.splice(item.itemIndex, 1)
      }
    }
  },
  // add allowRecursion's ip list
  addSplitDnsAllowrecursionData (state, data) {
    if (data !== null) {
      state.splitDnsSettings.allow_recursion.allow_list.push(data)
    }
  },
  // delete allowQuery's ip list
  delSplitDnsAllowrecursionData (state, itemIndexList) {
    if (itemIndexList !== null && itemIndexList !== undefined) {
      itemIndexList = _.orderBy(itemIndexList, ['itemIndex'], ['desc'])
      for (const item of itemIndexList) {
        state.splitDnsSettings.allow_recursion.allow_list.splice(item.itemIndex, 1)
      }
    }
  },
  // add allowRecursion's ip list
  addSplitDnsAllowtransferData (state, data) {
    if (data !== null) {
      state.splitDnsSettings.allow_transfer.allow_list.push(data)
    }
  },
  // delete allowQuery's ip list
  delSplitDnsAllowtransferData (state, itemIndexList) {
    if (itemIndexList !== null && itemIndexList !== undefined) {
      itemIndexList = _.orderBy(itemIndexList, ['itemIndex'], ['desc'])
      for (const item of itemIndexList) {
        state.splitDnsSettings.allow_transfer.allow_list.splice(item.itemIndex, 1)
      }
    }
  }
}

export const actions = {
  // get & add listen-on's ip list
  async getSplitDnsAdvConfigSet ({commit, state}) {
    const {code, result} = await this.$axios.$get(state.apiUrlPath['splitDnsAdvConfig'].replace('{type}', state.splitDnsDefault.type))
    // REAL CODE
    if (code !== undefined && code.toLowerCase() === 'ok') {
      commit('resetSplitDnsAdvConfigData')
      commit('setSplitDnsAdvConfigData', result)
    }
  },
  // splitDnsConfig - normalSet
  async setSplitDnsConfigNomarSet ({commit, state, dispatch}, isContinue) {
    commit('setSplitDnsNormalSetData', state.splitDnsNormaSetting)
    dispatch('setSplitDnsAdvConfigSet')
    if (!isContinue) {
      commit('resetSplitDnsNormalSetData')
    }
  },
  async setSplitDnsAdvConfigSet  ({commit, state}) {
    const res = {code: 'nok'}
    commit('resetSplitDnsRequestSetData')
    commit('setSplitDnsRequestSetData', state.splitDnsSettings)
    const url = state.apiUrlPath['splitDnsAdvConfig'].replace('{type}', state.splitDnsDefault.type)
    const putParam = _.cloneDeep(state.splitDnsReqSettings)
    // case outter dns : delete forwarders_list
    if (state.splitDnsDefault.type === 1) {
      putParam.forwarders_list = []
    }
    const rslt = await this.$axios.$put(url, putParam)
    if (rslt.code !== undefined && (rslt.code).toLowerCase() === 'ok') {
      res.code = 'ok'
      commit('setSplitDnsAdvConfigData', rslt.result)
      // commit common isChanage
      this.dispatch(`common/common/setIsChanged`, true)
    }
    return res
  },
  // add splitDns config-ListData
  async addSplitDnsConfigListData ({commit, state}, item) {
    const res = { code: 'ok' }
    const rsltData = {
      result: {
        ip: item.ip
      }
    }
    // check tabName
    if (item.tabName === 'listenOn') {
      commit('addSplitDnsListenonData', rsltData.result)
    } else if (item.tabName === 'forwarders') {
      commit('addSplitDnsForwardersData', rsltData.result)
    } else if (item.tabName === 'allowQuery') {
      commit('addSplitDnsAllowqueryData', rsltData.result)
    } else if (item.tabName === 'allowRecursion') {
      commit('addSplitDnsAllowrecursionData', rsltData.result)
    } else { // allowTransfer
      commit('addSplitDnsAllowtransferData', rsltData.result)
    }
    return res
  },
  // del splitDns config-ListData
  async delSplitDnsConfigListData ({commit, state}, item) {
    const res = { code: 'ok' }
    // check tabName
    if (item.tabName === 'listenOn') {
      commit('delSplitDnsListenonData', item.itemIndexList)
    } else if (item.tabName === 'forwarders') {
      commit('delSplitDnsForwardersData', item.itemIndexList)
    } else if (item.tabName === 'allowQuery') {
      commit('delSplitDnsAllowqueryData', item.itemIndexList)
    } else if (item.tabName === 'allowRecursion') {
      commit('delSplitDnsAllowrecursionData', item.itemIndexList)
    } else { // allowTransfer
      commit('delSplitDnsAllowtransferData', item.itemIndexList)
    }
    return res
  }
}

export const getters = {
  compareSplitDnsAdvConfigData (state) {
    return compareObject(state.cloneSplitDnsSettings, state.splitDnsNormaSetting)
  }
}

export const strict = false
